export default __webpack_public_path__ + "static/media/item_1@3x.07d454ed.webp";